export enum AppointmentActivityType {
  AppointmentCreated = 'appointment-created',
  AppointmentUpdated = 'appointment-updated',
  AppointmentCanceled = 'appointment-canceled',
  InfoCompleted = 'info-completed',
  RecurringAppointmentCreated = 'recurring-appointment-created',
  RecurringAppointmentUpdated = 'recurring-appointment-updated',
}
